import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddContractTypes, ContractTypes } from '../models/contracttypes/contracttypes';




@Injectable({
  providedIn: 'root'
})
export class ContractTypesService {

  constructor(
    private _http: HttpClient
  ) { }

    public getContractTypes(EmploymentContractTypesId?: number): Observable<ContractTypes[]>{
        return this._http.get<ContractTypes[]>(`${environment.api.url}/EmploymentContractTypes?EmploymentContractTypesId=${EmploymentContractTypesId??''}`);
    }
  
    public deleteContractTypes(EmploymentContractTypesId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/EmploymentContractTypes/${EmploymentContractTypesId}`);
    }
  
    public addContractTypes(model: AddContractTypes): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/EmploymentContractTypes`, model);
    }
}
